import { Check, SearchCheck, User2 } from "lucide-react";
import React from "react";

function SearchData({ searchResponse, onSelect, searchedUser }) {
  return (
    <>
      {searchResponse && (
        <div className=" bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
          {/* Header */}
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 border-b border-slate-200 text-slate-700 font-semibold text-sm">
            <SearchCheck size={18} className="text-blue-600" />
            Search Results
          </div>

          {/* Result List */}
          <div className="max-h-[220px] overflow-y-auto">
            {searchResponse?.data?.data?.length > 0 ? (
              searchResponse?.data?.data?.map((item, index) => (
                <button
                  type="button"
                  key={index}
                  onClick={() => onSelect(item)}
                  className="w-full flex items-center justify-between px-4 py-2 hover:bg-slate-50 transition"
                >
                  <div className="flex items-center gap-3">
                    {/* Avatar */}
                    <div className="h-8 w-8 flex items-center justify-center rounded-full bg-blue-100 text-blue-600">
                      <User2 size={16} />
                    </div>

                    {/* User ID */}
                    <span className="text-sm font-medium text-slate-700">
                      {item.user_id}
                    </span>
                  </div>

                  <span
                    className={`text-xs flex items-center gap-2  ${searchedUser?.user_id?.toLowerCase() === item.user_id?.toLowerCase() ? "text-green-700 bg-green-100 rounded-lg py-2 px-2" : " text-slate-600"}`}
                  >
                    {searchedUser?.user_id?.toLowerCase() ===
                    item.user_id?.toLowerCase() ? (
                      <>
                        <Check /> Selected
                      </>
                    ) : (
                      "Select"
                    )}
                  </span>
                </button>
              ))
            ) : (
              <div className="py-6 text-center text-sm text-slate-500">
                No users found
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default SearchData;
